// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelForm-Action_cls1__ezPzP","cls2":"PaymentChannelForm-Action_cls2__tt22u PaymentChannelForm-Action_cls1__ezPzP"};